export default __webpack_public_path__ + "static/11-af9b8766b4b8c5d4dcf164488137417b.jpg";